/**
     * @desc 取消报价
通过合约对NFT取消报价后，pending当前bid，预留接口暂未使用
id：bid的id
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/trading/cancelBid', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/trading/cancelBid', params);
}
